import React from 'react';

/**
 * NotesField Component
 * Renders a text input for notes with validation feedback.
 * Props:
 *  - state: form state object
 *  - handleChange: input change handler
 */
const NotesField = ({ state, handleChange }) => {
  return (
    // Container with floating label and position-relative for tooltips
    <div className="form-floating mb-4 position-relative">
      <input
        type="text"
        id="notes"
        name="notes"
        value={state.notes}
        onChange={handleChange}
        placeholder=" "
        autoComplete='off'
        // Apply validation classes conditionally: invalid if error, valid if value exists
        className={`form-control ${
          state.errors.notes ? 'is-invalid' : state.notes ? 'is-valid' : ''
        }`}
      />
      <label htmlFor="notes">Notes</label>

      {/* Show error tooltip when there is a validation error */}
      {state.errors.notes && (
        <div className="invalid-tooltip">{state.errors.notes}</div>
      )}

      {/* Show valid tooltip when notes have value and no errors */}
      {state.notes && !state.errors.notes && (
        <div className="valid-tooltip">Notes added</div>
      )}
    </div>
  );
};

export default NotesField;
